import IncidentsPage from 'containers/IncidentsPage';
import RegistrationContainer from 'containers/sign-up/registration';
import SignUp from 'containers/sign-up';
import SignUpUniversalPortal from 'containers/sign-up-universal-portal';
import Subscriptions from 'containers/sign-up/subscriptions/Subscriptions';
import SignUpProfile from 'containers/sign-up/Profile';
import MyLocation from 'containers/sign-up/address-information/AddressList';
import AdditionalInformation from 'containers/sign-up/additional-information';
import Review from 'containers/sign-up/review';
import NotificationCenter from 'containers/notification-center';
import NotificationList from 'containers/general-notification/list';
import NotificationDetail from 'containers/general-notification/detail';
import WeatherAlertList from 'containers/weather-alert/list';
import WeatherAlertDetail from 'containers/weather-alert/detail';
import CriticalEvents from 'containers/CriticalEvents';
import LoginContainer from 'containers/login';
import SsoLogin from 'containers/login/sso-login';
import EbLogin from 'containers/login/eb-login';
import ForgotPassword from 'containers/forgot-password';
import ForgotUsername from 'containers/forgot-username';
import ResetPassword from 'containers/reset-password';
import Overview from 'containers/overview';
import Home from 'containers/home';
import EventList from 'containers/events/EventList';
import EventDetail from 'containers/events/detail';
import Travel from 'containers/Travel';
import { GlobalContext } from 'commons';
import React, { useContext } from 'react';
import FilesLibrary from 'containers/filesLibrary';
import FAQs from '../FAQs';

export default ({
  enableReceiptTranscripts,
  orgId,
  contactIdPrivate,
  orgName,
  showSignUp,
  showCrisisTask,
  showCrisisSingleEventDashboard,
  showNotification,
  showWeather,
  showIncidents,
  showEvent,
  enabledSSO,
  showDirectoryChat,
  accountId,
  accessKey
}) => {
  const routes = [];

  const loginSubRoutes = [{
    component: EbLogin,
    props: {
      path: '/',
      key: 'route-login',
      activeName: 'login',
      showSignUp,
      enabledSSO,
      accountId,
      accessKey
    }
  }];
  const { flags: {
    PUBLIC_PORTAL_FORCE_NEW_ACCOUNT_TO_UP
  }, universalProfileUrl } = useContext(GlobalContext);


  if (enabledSSO) {
    loginSubRoutes.push({
      component: SsoLogin,
      props: {
        path: 'sso',
        key: 'route-sso-login',
        activeName: 'login',
        showSignUp,
        enabledSSO
      }
    });
  }
  routes.push({
    component: LoginContainer,
    props: {
      path: 'login',
      key: 'route-login-container',
      enabledSSO,
      accessKey
    },
    subRoutes: loginSubRoutes
  });

  routes.push({
    component: ForgotUsername,
    props: {
      path: 'forgot-username',
      key: 'route-forgot-username',
    }
  });

  routes.push({
    component: ForgotPassword,
    props: {
      path: 'forgot-password',
      key: 'route-forgot-password'
    }
  });

  routes.push({
    component: ResetPassword,
    props: {
      path: 'reset-password',
      key: 'reset-password'
    }
  });

  routes.push({
    component: FAQs,
    props: {
      path: 'faq',
      key: 'route-faqs'
    }
  });

  routes.push({
    component: Overview,
    props: {
      path: 'ov',
      key: 'route-overview'
    }
  });

  // Only add sign-up routes if the force flag is not enabled
  routes.push({
    component: SignUp,
    props: { path: 'new', key: 'route-sign-up' },
  });

  routes.push({
    component: SignUpUniversalPortal,
    props: { path: 'new-profile', key: 'route-public-sign-up' },
  });

  routes.push({
    component: FilesLibrary,
    props: {
      path: 'files',
      activeName: 'files',
      key: 'route-files-library',
    },
  });

  routes.push({
    component: RegistrationContainer,
    props: { path: 'new/account', key: 'route-registration-container' },
    subRoutes: [
      {
        component: MyLocation,
        props: { path: 'mylocation', key: 'route-sign-up-mylocation' },
      },
      {
        component: SignUpProfile,
        props: { path: 'profile', key: 'route-sign-up-profile' },
      },
      {
        component: Subscriptions,
        props: { path: 'subscriptions', key: 'route-subscriptions' },
      },
      {
        component: Review,
        props: { path: 'review', key: 'route-review' },
      },
      {
        component: AdditionalInformation,
        props: { path: 'additionalInformation', key: 'route-sign-up-additionalInfo' },
      },
      {
        component: MyLocation,
        props: { path: 'edit-mylocation', key: 'route-sign-up-mylocation' },
      },
      {
        component: SignUpProfile,
        props: { path: 'edit-profile', key: 'route-sign-up-profile' },
      },
      {
        component: Subscriptions,
        props: { path: 'edit-subscriptions', key: 'route-subscriptions' },
      },
      {
        component: AdditionalInformation,
        props: { path: 'edit-additionalInformation', key: 'route-sign-up-additionalInfo' },
      },
    ],
  });
  if (universalProfileUrl) {
    // Add a catch-all route for /new that redirects to Universal Portal
    routes.push({
      component: () => {
        window.location.href = `${universalProfileUrl}?orgId=${orgId}`;
        return null;
      },
      props: { path: 'new/*', key: 'route-sign-up-redirect' }
    });
  }

  routes.push({
    component: SignUpProfile,
    props: {
      path: 'my-profile',
      key: 'route-my-profile',
      isEditMode: true
    }
  });
  routes.push({
    component: MyLocation,
    props: {
      path: 'my-location',
      key: 'route-my-location',
      isEditMode: true
    }
  });
  routes.push({
    component: Subscriptions,
    props: {
      path: 'my-subscription',
      key: 'route-my-subscription',
      isEditMode: true
    }
  });
  routes.push({
    component: AdditionalInformation,
    props: {
      path: 'my-additionalInformation',
      key: 'route-my-additionalInformation',
      isEditMode: true
    }
  });

  if (showCrisisTask || showCrisisSingleEventDashboard) {
    routes.push({
      component: CriticalEvents,
      props: {
        path: 'cm/*',
        key: 'route-task-container',
        showCrisisTask,
        showCrisisSingleEventDashboard,
      },
    });
  }

  if (showNotification || showWeather) {
    routes.push({
      component: NotificationCenter,
      props: {
        path: 'notif/:notificationId',
        activeName: 'notif',
        RefComponent: NotificationDetail,
        key: 'route-notification-detail',
      },
    });

    routes.push({
      component: NotificationCenter,
      props: {
        path: 'notif',
        activeName: 'notif',
        RefComponent: NotificationList,
        key: 'route-notification-list',
      },
    });

    routes.push({
      component: NotificationCenter,
      props: {
        path: 'weather/:weatherAlertId',
        activeName: 'weather',
        RefComponent: WeatherAlertDetail,
        key: 'route-weather-alert-detail',
      },
    });

    routes.push({
      component: NotificationCenter,
      props: {
        path: 'weather',
        activeName: 'weather',
        RefComponent: WeatherAlertList,
        key: 'route-weather-alert-list',
      },
    });
  }

  if (showEvent) {
    // routes.push({
    //   component: NotificationCenter,
    //   props: {
    //     path: 'event/:eventId',
    //     activeName: 'event',
    //     RefComponent: NotificationDetail,
    //     key: 'route-event-detail',
    //   },
    // });

    routes.push({
      component: EventList,
      props: {
        path: 'event',
        activeName: 'event',
        key: 'route-event-list',
        isLoggedIn: !!accountId,
      },
    });
    routes.push({
      component: EventDetail,
      props: {
        path: 'event/:notificationId',
        activeName: 'event',
        key: 'route-event-detail'
      },
    });
  }

  if (showIncidents) {
    routes.push({
      component: IncidentsPage,
      props: {
        key: 'route-incidents',
        path: 'incidents',
        orgId,
        orgName,
      },
    });
  }

  routes.push({
    component: IncidentsPage,
    props: {
      key: 'route-chat',
      path: 'chat',
      activeName: 'chat',
      enableReceiptTranscripts,
      orgId,
      orgName,
    },
  });

  routes.push({
    component: Home,
    props: {
      path: 'portal-home',
      key: 'route-portal-home'
    }
  });
  routes.push({
    component: Home,
    props: {
      path: 'home',
      key: 'route-home'
    }
  });

  routes.push({
    component: Travel,
    props: {
      path: 'travel/*',
      key: 'route-travel'
    }
  });

  return routes;
};
